import { useSuspenseQuery } from '@tanstack/react-query';
import type { EditorialTileRow } from 'app/domain';
import { editorialTilesKeys } from '../keys';
import useApi from '../useApi';

// The row is fetched once, during the server render, and kept for the life of
// the page. Federation's defaults already set staleTime to Infinity; it is set
// here as well so the hydrated row is never refetched even if those change,
// because a failed refetch would replace live tiles with the fallback.
const useEditorialTiles = (
  page: string,
  previewIds: readonly string[] = []
): EditorialTileRow => {
  const { editorialTilesService } = useApi();

  const { data } = useSuspenseQuery<EditorialTileRow>({
    queryKey: editorialTilesKeys.row(page, previewIds),
    queryFn: async () => await editorialTilesService.getRow(page, previewIds),
    staleTime: Infinity,
  });

  return data;
};

export default useEditorialTiles;
